//      
import {connect} from "react-redux";
                                                  
import ProductPage from "../components/ProductPage";
import {resetProductScope, setProductScope} from "../actions/products";
                                    
import {resetCategory} from "../actions/filter";
import {customHistory} from "../helper/history";

                                   

function mapStateToProps(state                  , ownProps                           ) {
	const product = state.content.activeProduct || null;
	const galleryImage = ((product || {}).product || {}).galleryImage;
	const otherImages = (((product || {}).attachments || {}).images || [])
		.filter(it => it.name !== (galleryImage || {}).name);
	const videos = (((product || {}).attachments || {}).videos || []);

	return {
		detailedProduct: product,
		hasMultipleGalleryImages: product && product.attachments && product.attachments.images && product.attachments.images.length > 1,
		filter: {
			fuzzy: state.filter.fuzzy,
			category: state.filter.filter.selectedCategory
		},
		disclaimer: state.content.disclaimer,
		cartDisabled: state.cart.cartDisabled,
		images: galleryImage ? [...[galleryImage], ...(otherImages || [])] : (otherImages || []),
		videos: videos
	};
}

function mapDispatchToProps(dispatch          , ownProps                           ) {
	return {
		resetProductScope: () => {
			customHistory.push("/");
			dispatch(resetProductScope());
		},
		setProductScope: (productId        ) => {
			dispatch(setProductScope({id: productId}));
		},
		goBack: filter => {
			if (filter.fuzzy && filter.fuzzy.length >= 1) {
				return customHistory.push("/search/" + filter.fuzzy);
			} else if (filter.category && filter.category.key) {
				filter.category.count === 1 ? customHistory.push("/") : customHistory.push("/category/" + filter.category.key);
				dispatch(resetCategory());
			} else {
				customHistory.push("/");
			}
		}
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductPage);
